module.exports = "<div class=\"holder\" [@flyIn]=\"coupons?.length\">\n  <app-coupon *ngFor=\"let coupon of coupons\" [coupon]=\"coupon\" [isExtendedInfo]=\"isExtendedInfo\"></app-coupon>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/coupons-list/coupons-list.component.html
// module id = ./src/app/shared/coupons-list/coupons-list.component.html
// module chunks = main